
function NotAuthorized() {


   

    return (
        <div className='notfound-content'>
            <h1>401 You Are not Authorized <br></br></h1>
            <h2>Sorry, you are not authorized to view this page</h2>
        </div>
    );
}

export default NotAuthorized;
